import {HandelsregistereintragAngaben, StammdatenHandelsregisterBezeichnungEnum, StammdatenHandelsregistereintrag} from '@nachdigal';
import {Injectable} from '@angular/core';
import {AbstractMapper} from '../../abstract.mapper';

@Injectable()
export class HandelsregistereintragMapperService extends AbstractMapper<StammdatenHandelsregistereintrag, HandelsregistereintragAngaben> {

  private static getHandelsregisterBezeichnung(stammdatenHandelsregisterBezeichnung: StammdatenHandelsregisterBezeichnungEnum):
    StammdatenHandelsregisterBezeichnungEnum {
    if (stammdatenHandelsregisterBezeichnung == null) {
      return null;
    }
    for (const key in StammdatenHandelsregisterBezeichnungEnum) {
      if (stammdatenHandelsregisterBezeichnung === StammdatenHandelsregisterBezeichnungEnum[key]) {
        return StammdatenHandelsregisterBezeichnungEnum[key];
      }
    }
    return null;
  }

  protected mapInternal(source: StammdatenHandelsregistereintrag): HandelsregistereintragAngaben {
    return {
      istErfolgt: true,
      eingetragenAm: source.eingetragenAm,
      handelsregisterBezeichnung: HandelsregistereintragMapperService.getHandelsregisterBezeichnung(source.handelsregisterBezeichnung),
      handelsregisterNummer: source.handelsregisterNummer,
      ortRegistergericht: source.ortRegistergericht
    };
  }
}
